// store/plp/index.js

//inicio storage
const STORAGE_ORDER_FILTER = 'plp_order_filter';
const STORAGE_VEHICLE_DATA = 'plp_vehicle_data';
const STORAGE_INTERACTION = 'plp_interaction';
const STORAGE_SEARCH_VEHICLE_TIMESTAMP = 'plp_search_vehicle_timestamp';
const STORAGE_PRODUCT_SELECTED = 'plp_product_selected';

const getFiltroStorageKey = () => {
  if (typeof window === "undefined") {
    return "filtros_seleccionados";
  }

  const path = window.location?.pathname || "";

  if (path.startsWith("/neumaticos")) {
    return "filtros_seleccionados_neumaticos";
  }

  if (path.startsWith("/baterias")) {
    return "filtros_seleccionados_baterias";
  }

  return "filtros_seleccionados";
};

const getFromStorage = (key) => {
  try {
    if (import.meta.client) {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    }
  } catch (error) {
    console.warn(`Error leyendo ${key}:`, error);
  }
  return null;
};

const setToStorage = (key, data) => {
  try {
    if (import.meta.client) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  } catch (error) {
    console.warn(`Error guardando ${key}:`, error);
  }
};

const removeFromStorage = (key) => {
  try {
    if (import.meta.client) {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.warn(`Error eliminando ${key}:`, error);
  }
};
//termino storage

//inicio state
const state = function() {
  return {
    plpData: [],
    plpFilterData: [],
    plpFilterOrderValue: "",
    vehicleData: {},
    interaction: {},
    searchVehicleTimeStamp: null,
    productSelected: {},
    dashboardUUID: null,
    selectedBrandLogo: '',
    filtros_seleccionados: []
  };
};
//termino state

//inicio mutations
let expirationTimer;

const mutations = {
  setFiltros_seleccionados: function(state, values) {
    state.filtros_seleccionados = values;

    try {
      const key = getFiltroStorageKey();
      localStorage.setItem(key, JSON.stringify(values));
    } catch (e) {
      console.error("Error al guardar filtros_seleccionados en localStorage:", e);
    }
  },

  getFiltros_seleccionados: function(state) {
    try {
      const key = getFiltroStorageKey();
      const raw = localStorage.getItem(key);

      if (raw) {
        state.filtros_seleccionados = JSON.parse(raw) || [];
      } else {
        state.filtros_seleccionados = [];
      }
    } catch (e) {
      console.error("Error al leer filtros_seleccionados de localStorage:", e);
      state.filtros_seleccionados = [];
    }

    return state.filtros_seleccionados;
  },

  limpiarFiltros: function(state) {
    const key = getFiltroStorageKey();
    removeFromStorage(key);
    state.filtros_seleccionados = [];
  },

  setSelectedBrandLogo: function(state, logo) {
    state.selectedBrandLogo = logo;
  },

  updateFilterProducts: function(state, products) {
    state.plpFilterData = products;
  },

  updateProducts: function(state, products) {
    state.plpData = products;
  },

  updateFilterOrderValue: function(state, value) {
    localStorage.setItem(STORAGE_ORDER_FILTER, value);
    state.plpFilterOrderValue = value;
  },

  updateFilterOrderValueFromLocalStorage: function(state) {
    if (localStorage.getItem(STORAGE_ORDER_FILTER)) {
      state.plpFilterOrderValue = localStorage.getItem(STORAGE_ORDER_FILTER);
    } else {
      state.plpFilterOrderValue = "";
    }
  },

  updateVehicleData: function(state, vehicleData) {
    console.log("guardando en el store vehicleData: ", vehicleData);
    localStorage.setItem(STORAGE_VEHICLE_DATA, JSON.stringify(vehicleData));
    mutations.setSearchVehicleTimeStamp(state, Date.now().toString());
    state.vehicleData = vehicleData;
  },

  getVehicleData: function(state) {
    if (localStorage.getItem(STORAGE_VEHICLE_DATA)) {
      state.vehicleData = JSON.parse(localStorage.getItem(STORAGE_VEHICLE_DATA));
    } else {
      localStorage.setItem(STORAGE_VEHICLE_DATA, JSON.stringify([]));
      state.vehicleData = [];
    }
  },

  removeVehicleData: function(state) {
    localStorage.setItem(STORAGE_VEHICLE_DATA, JSON.stringify([]));
    state.vehicleData = [];
  },

  setInteraction: function(state, interaction) {
    let valor = JSON.stringify(interaction);
    localStorage.setItem(STORAGE_INTERACTION, valor);
    state.interaction = interaction;
  },

  getInteraction: function(state) {
    if (localStorage.getItem(STORAGE_INTERACTION)) {
      state.interaction = JSON.parse(localStorage.getItem(STORAGE_INTERACTION));
    } else {
      localStorage.setItem(STORAGE_INTERACTION, JSON.stringify({}));
      state.interaction = {};
    }
  },

  getSearchVehicleTimeStamp: function(state) {
    const searchVehicleTimeStamp = localStorage.getItem(STORAGE_SEARCH_VEHICLE_TIMESTAMP)
      ? parseInt(localStorage.getItem(STORAGE_SEARCH_VEHICLE_TIMESTAMP))
      : null;
    state.searchVehicleTimeStamp = searchVehicleTimeStamp;
  },

  setSearchVehicleTimeStamp: function(state, searchVehicleTimeStamp) {
    localStorage.setItem(STORAGE_SEARCH_VEHICLE_TIMESTAMP, searchVehicleTimeStamp);
    state.searchVehicleTimeStamp = searchVehicleTimeStamp;

    mutations.startExpirationTimerVehicleData(state);
  },

  startExpirationTimerVehicleData: function(state) {
    const config = useRuntimeConfig();
    const expirationMinutes = config.public.timeSearchReset;

    mutations.getSearchVehicleTimeStamp(state);

    const expirationTimestamp =
      state.searchVehicleTimeStamp + expirationMinutes * 60 * 1000;
    const currentTime = Date.now();

    if (expirationTimer) {
      clearTimeout(expirationTimer);
    }

    if (expirationTimestamp > currentTime) {
      const timeLeft = expirationTimestamp - currentTime;
      expirationTimer = setTimeout(() => {
        mutations.resetVehicleData(state);
      }, timeLeft);
    } else {
      mutations.resetVehicleData(state);
    }
  },

  resetVehicleData: function(state) {
    localStorage.setItem(STORAGE_SEARCH_VEHICLE_TIMESTAMP, null);
    state.searchVehicleTimeStamp = null;
    clearTimeout(expirationTimer);
    expirationTimer = null;
  },

  verifySearchVehicleTimeStamp: function(state) {
    mutations.getSearchVehicleTimeStamp(state);

    const config = useRuntimeConfig();
    const expirationMinutes = config.public.timeSearchReset;

    const currentTime = Date.now() - expirationMinutes * 60 * 1000;

    if (currentTime <= state.searchVehicleTimeStamp) {
      expirationTimer = setTimeout(() => {
        mutations.resetVehicleData(state);
      }, state.searchVehicleTimeStamp - currentTime);
    } else {
      mutations.resetVehicleData(state);
    }
  },

  updateProductSelected: function(state, productSelected) {
    localStorage.setItem(STORAGE_PRODUCT_SELECTED, JSON.stringify(productSelected));
    state.productSelected = productSelected;
  },

  resetProductSelected: function(state) {
    localStorage.setItem(STORAGE_PRODUCT_SELECTED, null);
    state.productSelected = null;
  },

  getProductSelected: function(state) {
    if (localStorage.getItem(STORAGE_PRODUCT_SELECTED)) {
      state.productSelected = JSON.parse(localStorage.getItem(STORAGE_PRODUCT_SELECTED));
    } else {
      localStorage.setItem(STORAGE_PRODUCT_SELECTED, null);
      state.productSelected = null;
    }
  },
};
//termino mutations

//inicio getters
const getters = {};
//termino getters

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {}
};